const DEFAULT_INTERVAL_MS = 8000

function normalizeStatusMessages(changingText) {
    if (changingText == null) return []
    const list = Array.isArray(changingText) ? changingText : [changingText]
    return list.map((item) => (typeof item === 'string' ? item.trim() : '')).filter(Boolean)
}

function resolveIntervalMs(intervalMs) {
    const n = Number(intervalMs)
    if (!Number.isFinite(n) || n <= 0) return DEFAULT_INTERVAL_MS
    return n
}

function shouldUseAgencyLogo(siteMaster) {
    if (!siteMaster) return false
    if (Number(siteMaster.siteId) === 1) return false
    return typeof siteMaster.siteLogo === 'string' && siteMaster.siteLogo.trim().length > 0
}

/**
 * Schedule status index advances. Starts from index 0 (owned by caller).
 * Calls onChange(nextIndex) for each advance; holds on last. Returns cleanup.
 */
function startStatusRotation({
    messages,
    intervalMs,
    onChange,
    setTimeoutFn = setTimeout,
    clearTimeoutFn = clearTimeout
}) {
    if (!Array.isArray(messages) || messages.length < 2) {
        return () => { }
    }
    const ms = resolveIntervalMs(intervalMs)
    let index = 0
    let timerId

    const schedule = () => {
        if (index >= messages.length - 1) return
        timerId = setTimeoutFn(() => {
            index += 1
            onChange(index)
            schedule()
        }, ms)
    }

    schedule()

    return () => {
        if (timerId != null) clearTimeoutFn(timerId)
    }
}

module.exports = {
    DEFAULT_INTERVAL_MS,
    normalizeStatusMessages,
    resolveIntervalMs,
    shouldUseAgencyLogo,
    startStatusRotation
}
